import axios from 'axios';
import type { RouteRecordNormalized } from 'vue-router';
import { UserState } from '@/store/modules/user/types';

export interface LoginData {
  username: string;
  password: string;
}

export interface LoginRes {
  token: string;
}

export interface Role {
  id: number;
  createdAt: string;
  updatedAt: string;
  creator: string | null;
  updater: string | null;
  name: string;
  value: string;
  remark: string;
  status: number;
  default: number | null;
}

export interface Merchant {
  id: number;
  createdAt: string;
  updatedAt: string;
  merchantName: string;
  status: number;
}

export interface UserProfile {
  id: number;
  createdAt: string;
  updatedAt: string;
  username: string;
  nickname: string | null;
  avatar: string | null;
  qq: string | null;
  email: string | null;
  phone: string | null;
  remark: string | null;
  status: number;
  roles: Role[];
  merchant: Merchant;
}

export function login(data: LoginData) {
  return axios.post<LoginRes>('/api/auth/login', data);
}

export function logout() {
  return axios.post<LoginRes>('/api/user/logout');
}

export function getUserInfo() {
  return axios.get<UserProfile>('/api/account/profile');
}

export interface UpdateProfileParams {
  nickname?: string;
  email?: string;
  phone?: string;
  remark?: string;
  avatar?: string;
}

export function updateProfile(params: UpdateProfileParams) {
  return axios.put<UserProfile>('/api/account/profile', params);
}

export function getMenuList() {
  return axios.post<RouteRecordNormalized[]>('/api/user/menu');
}
